import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Tag, ConfirmAbortModal } from "@ts-digital/vrc";
import { faPenAlt, faUser } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.css";
import { useSelector, useDispatch } from "react-redux";

function formatDate(date) {
  let dateJs = new Date(date);
  return (
    dateJs.getDate() +
    "/" +
    (dateJs.getMonth() + 1) +
    "/" +
    dateJs.getFullYear()
  );
}

function translateSignatureType(type) {
  switch (type) {
  case "BioSignature":
  case "FGA - BioSignature":
  case "FEA grafometrica":
    return "Firma Avanzata su tavoletta grafometrica";
  case "FES grafometrica":
    return "Firma Semplice su tavoletta grafometrica";
  case "SecureCall":
  case "FEA remota":
    return "Firma Avanzata remota";
  case "FSM":
  case "FEQ remota":
    return "Firma Qualificata remota";
  case "FES remota":
    return "Firma Semplice remota";

  default:
    return type;
  }
}

const SignatureCard = ({  signDocument, rowData }) => {
  const [visibleSignDialog, setvisibleSignDialog] = useState(false);
  const navigate = useNavigate();
  const auth = useSelector(state => state.auth);
  const dispatch = useDispatch();

  const toggleSignDialog = () => {
    setvisibleSignDialog(!visibleSignDialog);
  };
  const signatureLabel = rowData.signatureProcessName
    ? rowData.signatureProcessName
    : rowData.signatureLabel;
  let expiryDate;
  let documentSigners;
  let hubId = rowData.hubId;
  let signatureType = translateSignatureType(signatureLabel).toUpperCase();
  let documentType = rowData.documentTypeDetail.title
    ? rowData.documentTypeDetail.title
    : null;
  let grafometrica = false;
  if (
    signatureLabel === "BioSignature" ||
    signatureLabel === "FGA - BioSignature" ||
    signatureLabel === "FEA grafometrica"
  ) {
    grafometrica = true;
  }
  if (rowData) {
    expiryDate = (
      <div className="description">
        Scadenza:
        <div className="bold-text">{formatDate(rowData.expiryDate)}</div>
      </div>
    );

    documentSigners = (
      <div className="description-signers">
        Firmatari:
        {rowData.documentSigners.map(item => (
          <div className="icon-container" key={item}>
            <FontAwesomeIcon className="icon-user" icon={faUser} />
            {item}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="signature-card">
      <div className="card">
        <div className="tag-container">
          <Tag type="ghost" maxWidth={500}>
            {signatureType}
          </Tag>
        </div>
        <div className="title">{documentType}</div>
        <div className="details">
          {expiryDate}
          {documentSigners}
        </div>
      </div>
      <div className="footer">
        {!grafometrica ? (
          <span className="icon-sign">  <FontAwesomeIcon icon={faPenAlt} onClick={toggleSignDialog.bind(this)} /></span>
        ) : <span className="icon-sign icon-sign-disabled"><FontAwesomeIcon  icon={faPenAlt} /></span>}
      </div>
      <ConfirmAbortModal
        title="Sei sicuro di voler firmare questo file? "
        confirmText="Firma"
        abortText="Annulla"
        closable={true}
        visible={visibleSignDialog}
        onAbort={() => toggleSignDialog()}
        onConfirm={e => {
          if (window.aptrinsic) {
            window.aptrinsic("track", "digital-box:DOCUMENT_SIGN");
          }
          navigate("/firma-documento");
          dispatch(signDocument(auth, hubId));
          toggleSignDialog();
        }}
      >
        <div style={{ minWidth: "450px" }} />
      </ConfirmAbortModal>
    </div>
  );
};

SignatureCard.propTypes = {
  signDocument: PropTypes.func,
  rowData: PropTypes.object
};

export default SignatureCard;
